class AdminActionsApi {
  constructor(client) {
    this.client = client
  }

  banRoomCustomer(room, reason) {
    const params = {
      hash: room.customer.hash,
      professional_name: room.professional.name,
      room_id: room.id,
      reason,
    }

    return this.client.post(`admin/v1/customers/${room.customer.hash}/ban`, params)
  }

  unBanRoomCustomer(room) {
    const params = {
      hash: room.customer.hash,
      professional_name: room.professional.name,
    }

    return this.client.post(`admin/v1/customers/${room.customer.hash}/unban`, params)
  }

  fetchRoomCustomer(room) {
    const params = {
      userHash: room.customer.hash,
    }
    this.client.defaults.headers.common['apikey'] = room.api_key
    return this.client.get(`2/userdata`, { params })
  }
}

export default AdminActionsApi
